import * as Roles from '@/store/roles';

/* Check permissions on save(update) properties */
const stagePropertiesValidate = (userRole, update) => {
  if (userRole === Roles.SubContractor || userRole === Roles.Client) {
    if (
      update &&
      update.newStageProperties.hasOwnProperty('showChildren') &&
      Object.keys(update.newStageProperties).length === 1
    ) {
      return true;
    }
    return false;
  }

  /* Apply restrictions on SiteAssistant/Manager */
  if (userRole === Roles.SiteManager || userRole === Roles.SiteAssistant) {
    // Default false. Fixes bug in Panel for SiteManagers/Assistants
    if (!update || !update.newStageProperties) {
      return false;
    }
    if (
      update.newStageProperties.hasOwnProperty('title') ||
      update.newStageProperties.hasOwnProperty('archived') ||
      update.newStageProperties.hasOwnProperty('colour') ||
      update.newStageProperties.hasOwnProperty('lockedDragNDrop') ||
      update.newStageProperties.hasOwnProperty('stageOccupation')
    ) {
      return false;
    }
    return true;
  }

  return true;
};

export const stageActionsPermissions = {
  addStageRootLevel: [Roles.Admin, Roles.ProjectLeader], // Allow the creation of stages in top root level. (added 2020-12-02)
  editStageRootLevel: [Roles.Admin, Roles.ProjectLeader], // Allow editing of stages in top root level. (added 2020-12-02)
  addStage: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addSyncedStage: [Roles.Any],
  closeAllTopLevelStages: [Roles.Any],
  deleteStage: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  duplicateStage: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  moveStageChildren: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  moveStageChildrenRecurse: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  openAllTopLevelStages: [Roles.Any],
  saveStageProperties: stagePropertiesValidate, // Check permission based on updated properties (fields)
  selectStage: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  setStageProperties: stagePropertiesValidate,
  showAllChildren: [Roles.Any],
  showAllChildrenRecurse: [Roles.Any],
  syncStageProperties: [Roles.Any],
  toggleStageChildren: [Roles.Any],
  updateChildrenColours: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  viewStageWorkHours: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  updateChildrenColoursRecurse: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  updateStagePropertyWithClear: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  updateStagePropertyWithClearRecurse: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
};



// WEBPACK FOOTER //
// ./src/store/stage/stageActionsPermissions.js